import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/outline";
import React, { useState } from "react";
import classNames from "../../utils/classNames";
import { PriceTiers } from "../../utils/types";

interface Props {
  title: string;
  items: PriceTiers[] | null | undefined;
  titleClassName?: string;
}

const PricingTable: React.FC<Props> = ({ items, title, titleClassName }) => {
  const [opened, setOpened] = useState(false);

  return (
    <div className="flex w-full items-center flex-col dark:text-gray-200">
      <div className={classNames("flex w-full justify-center", titleClassName)}>
        <span
          className="flex items-center cursor-pointer"
          onClick={() => setOpened((prevState) => !prevState)}
        >
          <span className="font-semibold mr-2 text-sm">
            {opened ? "Hide" : "Show"} pricing table
          </span>

          {opened ? (
            <ChevronUpIcon className="h-4 w-4" aria-hidden="true" />
          ) : (
            <ChevronDownIcon className="h-4 w-4" aria-hidden="true" />
          )}
        </span>
      </div>

      {opened && (
        <div className="flex w-full flex-col mt-5">
          <div className="flex items-center justify-between dark:text-gray-200 mb-4">
            <span className="font-bold text-sm sm:text-base">{title}</span>
            <span className="font-bold text-sm sm:text-base">Unit cost</span>
          </div>

          {items?.map((item, index) => (
            <div className="flex items-center justify-between mb-4" key={index}>
              <span className="w-4/12 sm:w-2/12 font-light text-xs sm:text-sm">
                {(items[index - 1]?.up_to || 0) + 1} - {""}
                {item.up_to || "∞"}
              </span>
              <hr className="w-5/12 sm:w-9/12 border-gray-400" />
              <span className="text-right w-2/12 sm:w-1/12 font-light text-xs sm:text-sm">
                ${(item.unit_amount / 100).toFixed(2)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PricingTable;
